import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import '@/utils/flexible.js';

import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
// 导入store
import store from './store';

createApp(App).use(router).use(ElementPlus).use(store).mount('#app');
